import { MtStudyTeamMember } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"

export const setStudyTeamMemberList = (teamMemberList: types.StudyTeamMemberList) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_LIST),
    teamMemberList,
})
export const setStudyTeamMemberListByStudy = (teamMemberListByStudy: types.StudyTeamMemberListByStudy) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_LIST_BY_STUDY),
    teamMemberListByStudy,
})
export const setStudyTeamMemberIds = (teamMemberIds: readonly number[]) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_IDS),
    teamMemberIds,
})
export const setStudyTeamMemberView = (teamMember: MtStudyTeamMember) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_VIEW),
    teamMember,
})
export const setStudyTeamMemberEdit = (teamMember: MtStudyTeamMember) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_EDIT),
    teamMember,
})


export const setStudyTeamMemberSort = (sortColumn: keyof MtStudyTeamMember, sortOrder: OrderType) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_SORT),
    sortColumn,
    sortOrder,
})
export const setStudyTeamMemberFilters = (filters: types.StudyTeamMemberFilters) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_FILTERS),
    filters,
})


export const setStudyTeamMemberReloadList = (value: boolean) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_RELOAD_LIST),
    value,
})
export const setStudyTeamMemberReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.STUDY_TEAM_MEMBER_RELOAD_EDIT),
    value,
})
